const initState = {

    loading: null,
    errore: null,
    reports: null,
    reportsScopeKey: null,
};

const reportReducer = (state = initState, action) => {



    switch (action.type) {

        case 'GET_REPORTS_REQUEST': {
            const isScopeChange =
                action.scopeKey != null && action.scopeKey !== state.reportsScopeKey;
            return {
                ...state,
                loading: true,
                reports: isScopeChange ? [] : state.reports,
                reportsScopeKey: action.scopeKey ?? state.reportsScopeKey,
                error: null,
            };
        }

        case 'GET_REPORTS_SUCCESS':
            if (
                action.scopeKey != null &&
                state.reportsScopeKey != null &&
                action.scopeKey !== state.reportsScopeKey
            ) {
                return state;
            }
            return {
                ...state,
                loading: false,
                reports: action.report,
                reportsScopeKey: action.scopeKey ?? state.reportsScopeKey,
                error: null,
            };


        case 'GET_REPORTS_FAILURE':
            return {
                ...state,
                loading: false,
                error: action.error,
            };

         case 'GET_REPORT_SUCCESS':
            return {
                ...state,
                loading: false,
                currentReport:  action.payload,
                error: null,
            };

            
        case 'CREATE_REPORT_SUCCESS':
            return {
                ...state,
                loading: false,
                currentReport: action.report,
                error: null,
            };

        case "REPORT_DELETED":
            return {
                ...state,
                reports: state.reports.filter(report => report.id !== action.payload),
            }

        case 'CLEAR_CURRENT_REPORT':
            return {
                ...state,
                currentReport: null,
  };
        

        default:
            return state;
    }
};

export default reportReducer;
